<template>
  <section>
    <div
      v-if="showVriendenloterijVipCardBanner"
      class="prose prose--app prose--app--text-xs prose--app--font-semibold prose--app--w-full bg-app-secondary-4-yellow--light-portica my-5 px-4 py-2"
      v-html="globalStore.vriendenloterij.introduction"
    ></div>
    <ul class="additional-info-list border-app-primary-grey--concrete border-t">
      <li v-for="(item, index) in items" :key="index" :class="{ 'mb-1': index + 1 === items.length }">
        <MoleculeInfoPanel :id="`info-panel-${index}`" class="border-b-0 border-t-0" :class="{ 'pt-0': index !== 0 }" :hide-exclamation-mark="index !== 0"
          ><span v-html="item.description"
        /></MoleculeInfoPanel>
      </li>
    </ul>
  </section>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'

const props = defineProps({
  additionalCostDescription: { type: String, required: false, default: '' },
  beverages: { type: Boolean, required: false, default: false },
  beverageDescription: { type: String, required: false, default: '' },
  showVriendenloterijVipCardBanner: { type: Boolean, required: false, default: false },
})

const { t } = useI18n()
const globalStore = useGlobalStore()

/** A label/description pair rendered as one row of the additional-info list. */
const items = ref<{ label: string; description: string }[]>([])
// The CMS translation entries use this misspelling ("bevarages"), not "beverages" - matching it here to
// avoid a missing-key warning, not introducing it.
if (props.beverages && props.beverageDescription) {
  items.value.push({
    label: t('concert.detail.bevarages-included-title'),
    description: props.beverageDescription || t('concert.detail.bevarages-included'),
  })
} else {
  items.value.push({
    label: t('concert.detail.bevarages-included-title'),
    description: props.beverages ? t('concert.detail.bevarages-included') : t('concert.detail.bevarages-excluded'),
  })
}

items.value.push({
  label: t('concert.detail.additional-costs-title'),
  description: props.additionalCostDescription || t('concert.detail.additional-costs'),
})
</script>

<style lang="scss">
// cannot be scoped, link style won't work
.additional-info-list a {
  text-decoration: underline;
}

#info-panel-0 {
  align-items: flex-start;
}
</style>
